module.exports = {
  "country": "LU",
  "artist": "Anne-Maire David",
  "song": "Tu te reconnaîtras",
  "year": "1973",
  "place": "1",
  "spotify": "3682WlWtLmx44QNpB6Py4X"
};